import React, { useState, useEffect } from "react";
import { Url } from "../../url";
import './../../entrydoor.css';
import './DoorItems.css';

const DoorItems = ({ value, onChange, selectedCollection, selectedGrainFilter, 
                                      doorSizeValueToFunc, doorHeightValueToFunc, passSelectedDoor, searchByName = null,
                                      label = "Panels" }) => {
    const [items, setItems] = useState(value||[]);
    const [selectedPanel, setSelectedPanel] = useState(null);

    useEffect(() => {
        if (!items || items.length === 0) {
            console.log("unselect door panel");
            setSelectedPanel(null);
            onChange(null);
        }
    }, [items]);
    
    useEffect(() => {
        if (doorSizeValueToFunc){;}
        if (doorHeightValueToFunc){;}
        if (searchByName){;}
        let collectionValue = selectedCollection;
        if (!selectedCollection) { // Dynamically fetch selectedCollection if it's not provided
            const collectionElement = document.getElementById('DoorCollection');
            if (collectionElement) {
                collectionValue = collectionElement.value;
            }
        }

        // Ensure we continue if at least one filter is defined
        if (!collectionValue && !selectedGrainFilter && !doorSizeValueToFunc && !doorHeightValueToFunc && !searchByName) return;

        //fetch(`${Url}/doorpanels?width=${doorSizeValueToFunc}"&height=${doorHeightValueToFunc}"`) // Pass width and height as query parameters
        let w = doorSizeValueToFunc + "\"";
        let h = doorHeightValueToFunc + "\"";
        const url = `${Url}/doorpanels?width=${w}&height=${h}`; 
        //const url = "http://172.30.0.2:5000/doorpanels?width=32\"&height=6'8\""
        console.log("url:=>", url)
        //fetch(`${Url}/doorpanels`)
        fetch(url) 
            .then((response) => response.json())
            .then((data) => {
                let filteredItems = data;

                // Apply the 'panel' filter only if collectionValue is valid
                if (collectionValue && collectionValue !== "") {
                    filteredItems = filteredItems.filter(item => item.panel === collectionValue);
 
                }
                if (doorSizeValueToFunc && doorSizeValueToFunc !== "") {
                    //filteredItems = filteredItems.filter(item => item.width === doorSizeValueToFunc + "\"");
                }
                if (doorHeightValueToFunc && doorHeightValueToFunc !== "") {
                    //filteredItems = filteredItems.filter(item => item.height === doorHeightValueToFunc + "\"");
                }
                if (selectedGrainFilter && selectedGrainFilter !== "") {
                    filteredItems = filteredItems.filter(item => item.grain === selectedGrainFilter);
                }
                if (searchByName) {
                    filteredItems = filteredItems.filter(item => item.value.toLowerCase().includes(searchByName.toLowerCase()));
                }
                
                if (!Array.isArray(filteredItems)) {
                    console.error("Filtered items is not an array!", filteredItems);
                    setItems([]); // Fallback to an empty array
                    return;
                }
                setItems(filteredItems);
            })
            .catch((error) => {
                console.error("Error fetching items:", error);
                alert("An error occurred while fetching items.");
            });
    }, [selectedCollection, selectedGrainFilter,
        doorSizeValueToFunc, doorHeightValueToFunc, passSelectedDoor, searchByName]); // Dependency array ensures updates trigger

    // onSelect function to handle item selection and unselection
    const handleSelect = (item) => {
        // If the clicked item is already selected, unselect it by setting selectedItem to null
        if (selectedPanel && selectedPanel.id === item.id) {
            setSelectedPanel(null);  // Unselect the item
            onChange(null);  // Notify parent with null to indicate no item is selected
        } else {
            setSelectedPanel(item);  // Select the item
            onChange(item);  // Notify parent with the selected item
        }
    };

    return (
        <div className="a-container">
            <label htmlFor="DoorItems">{label}</label>
            <div className="door-items-container">
                {Array.isArray(items) && items.length > 0 ? (
                    items.map((item) => (
                        <div
                            key={item.id}
                            className="door-item"
                            //className={`door-item ${selectedPanel?.id === item.id ? 'selected' : ''}`}
                            onClick={() => handleSelect(item)} // Add click handler
                            style={{
                                cursor: "pointer",
                                textAlign: "center", // Ensure child elements are centered
                                width: '120px',
                                display: "flex", // Use flexbox
                                flexDirection: "column", // Stack content vertically
                                alignItems: "center", // Horizontal alignment
                                justifyContent: "flex-start", // Align images and content to the top
                              }}
                            //style={{ cursor: 'pointer' }} // Optional: visual feedback
                        >
                        <img
                          src={`images/${item.image}`}
                          alt={item.value}
                          aria-label={`Panel item ${item.value}`}
                          style={{
                            alignSelf: "center", // Optional: align image if needed
                            verticalAlign: "top", // Align the image to the top
                          }}
                        />
                            <p
                            style={{
                                fontWeight:
                                selectedPanel && selectedPanel.id === item.id
                                    ? "bold"
                                    : "normal",
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                                overflowWrap: "break-word", // Break long words
                                textAlign: "center",
                                lineHeight: "1.2", // Adjust for better line spacing
                                margin: "5px 0", // Add some space around the text
                            }}
                            >
                            {item.value}
                            </p>
                        </div>
                    ))
                ) : (
                    <p>No items available for the selected collection or grain filter.</p>
                )}
            </div>
        </div>
    );
    
};

export default DoorItems;
